import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestStatsButtonsClickedGet = {
    path: "/stats/buttonsClicked",
    method: RouteHttpVerb.GET
};
